import React, { useEffect, useState } from 'react';
import { RoofingCalculator } from './components/RoofingCalculator';
import { CompetitorComparison } from './pages/CompetitorComparison';
export type RoofType = 'gaf' | 'owens_corning' | 'tile' | 'new_tile';
export interface Competitor {
  name: string;
  pricePerSq: number;
  color: string;
}
export interface RoofTypeConfig {
  id: RoofType;
  label: string;
  costPerSq: number;
  sellingPrices: number[];
  normalPricePerSq: number;
  targetMargin: number;
  warranty: string | null;
  available: boolean;
  competitors: Competitor[];
}
export const ROOF_TYPES: Record<RoofType, RoofTypeConfig> = {
  gaf: {
    id: 'gaf',
    label: 'GAF',
    costPerSq: 350,
    sellingPrices: [550, 575, 600, 625, 650, 675, 700, 725, 750, 775, 800],
    normalPricePerSq: 775,
    targetMargin: 6000,
    warranty: null,
    available: true,
    competitors: [{
      name: 'Master Roofing',
      pricePerSq: 800,
      color: 'bg-slate-700'
    }, {
      name: 'Dabella',
      pricePerSq: 1000,
      color: 'bg-red-800'
    }]
  },
  owens_corning: {
    id: 'owens_corning',
    label: 'Owens Corning',
    costPerSq: 385,
    sellingPrices: [550, 575, 600, 625, 650, 675, 700, 725, 750, 775, 800],
    normalPricePerSq: 775,
    targetMargin: 6000,
    warranty: '50 Year Warranty',
    available: true,
    competitors: [{
      name: 'Master Roofing',
      pricePerSq: 800,
      color: 'bg-slate-700'
    }, {
      name: 'Dabella',
      pricePerSq: 1000,
      color: 'bg-red-800'
    }]
  },
  tile: {
    id: 'tile',
    label: 'Tile',
    costPerSq: 365,
    sellingPrices: [550, 575, 600, 625, 650, 675, 700, 725, 750, 775, 800],
    normalPricePerSq: 775,
    targetMargin: 6000,
    warranty: null,
    available: true,
    competitors: [{
      name: 'Master Roofing',
      pricePerSq: 800,
      color: 'bg-slate-700'
    }, {
      name: 'Dabella',
      pricePerSq: 1000,
      color: 'bg-red-800'
    }]
  },
  new_tile: {
    id: 'new_tile',
    label: 'New Tile',
    costPerSq: 650,
    sellingPrices: [900, 925, 950, 975, 1000, 1025, 1050, 1075, 1100],
    normalPricePerSq: 1100,
    targetMargin: 6000,
    warranty: null,
    available: true,
    competitors: [{
      name: 'Master Roofing',
      pricePerSq: 1200,
      color: 'bg-slate-700'
    }, {
      name: 'Dabella',
      pricePerSq: 1600,
      color: 'bg-red-800'
    }]
  }
};
type Page = 'calculator' | 'comparison';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('calculator');
  const [squares, setSquares] = useState<number>(30);
  const [roofType, setRoofType] = useState<RoofType>('gaf');
  const [sellingPrice, setSellingPrice] = useState<number>(550);
  const config = ROOF_TYPES[roofType];
  // When roof type changes, auto-select the first valid selling price that meets margin
  useEffect(() => {
    const validPrice = config.sellingPrices.find(price => (price - config.costPerSq) * squares >= config.targetMargin) || config.sellingPrices[0];
    if (validPrice && !config.sellingPrices.includes(sellingPrice)) {
      setSellingPrice(validPrice);
    }
  }, [roofType]);
  if (currentPage === 'comparison') {
    return <CompetitorComparison squares={squares} sellingPrice={sellingPrice} roofConfig={config} onBack={() => setCurrentPage('calculator')} data-id="element-0" />;
  }
  return <RoofingCalculator squares={squares} setSquares={setSquares} sellingPrice={sellingPrice} setSellingPrice={setSellingPrice} roofType={roofType} setRoofType={setRoofType} roofConfig={config} onViewComparison={() => setCurrentPage('comparison')} data-id="element-1" />;
}